import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as actions from './actions';
import * as selectors from './selectors';
import {
  actions as activityActions,
  constants as activityConstants,
  utils as activityUtils,
} from './../../ducks/activity';

export const initialize = () => (dispatch) => (
  dispatch(actions.getGroupList())
    .then((response) => {
      const groupIds = response.data.results.map((group) => group.id);

      if (!groupIds.length) {
        return response;
      }

      return dispatch(activityActions.getGroupsActivity({
        groupIds,
        since: activityUtils.xDaysAgo(activityConstants.CHARTS_DATA_PERIOD),
      }));
    })
);

export const createGroup = (payload) => (dispatch, getState) => {
  const organizationId = selectors.organizationSelector(getState()).organization.id;

  return dispatch(actions.createGroup({ ...payload, organizationId }))
    .then(() => dispatch(notificationActions.notifySuccess('Group created!')));
};

export const removeGroups = (groupIds) => (dispatch, getState) => {
  const allGroups = selectors.groupsSelector(getState()).groups;
  const removeActions = groupIds.map((id) => actions.removeGroup({ id }));

  const dispatchedActions = removeActions.map((action) => (
    dispatch(action).catch(({ groupId }) => {
      const groupName = groupId ? allGroups.find((group) => group.id === groupId).name : '';
      dispatch(notificationActions.notifyDanger(`Unable to delete group ${groupName}`));
    })
  ));

  return Promise.all(dispatchedActions);
};
